"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configureIMSData = void 0;

var _react = require("react");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Method used to check imsData object
 * @param {object} imsData - imsData object with potentially misconfigured values
 * @return {Object} reconfigured imsData
 */
var configureIMSData = function configureIMSData() {
  var imsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = imsData.id,
      _imsData$token = imsData.token,
      token = _imsData$token === void 0 ? '' : _imsData$token,
      authId = imsData.authId;
  var isLoggedIn = Boolean(token);
  var formattedToken = !isLoggedIn || token.includes(_constants.USER_TOKEN_PREFIX) ? token : "".concat(_constants.USER_TOKEN_PREFIX, " ").concat(token);
  return _objectSpread(_objectSpread({}, imsData), {}, {
    id: !id || id.includes(_constants.USER_ID_PREFIX) ? id : _constants.USER_ID_PREFIX + id,
    token: formattedToken,
    // helper against substring checks
    isGuestUser: formattedToken.includes('AnonBearer'),
    // helper against token existence checks
    isLoggedIn: isLoggedIn,
    authId: !authId || authId.includes(_constants.USER_ID_PREFIX) ? authId : _constants.USER_ID_PREFIX + authId
  });
};

exports.configureIMSData = configureIMSData;

var useIMSData = function useIMSData(imsData) {
  var prevIMSData = (0, _react.useRef)(configureIMSData(imsData)); // Memoize standardized IMS and asset data

  var configuredIMSData = (0, _react.useMemo)(function () {
    var newIMSData = configureIMSData(imsData);

    if (!(0, _lodash.default)(prevIMSData.current, newIMSData)) {
      prevIMSData.current = newIMSData;
      return newIMSData;
    }

    return prevIMSData.current;
  }, [imsData]);
  return configuredIMSData;
};

var _default = useIMSData;
exports.default = _default;